
import useProjectNewAddData from '@/views/web/project-new-add/hooks/useProjectNewAddData';
import Link from 'next/link';
import HomeTitle from '@/comps/HomeTitle'
import { dateFormat } from 'libs/utils';
// import { useRouter } from 'next/router';
import { cls } from 'reactutils';
import Image from 'next/image';
import Icon from './icon.png'
import ProjectNewAddBg from '@/images/cscec3b/home/project-new-add-bg.png'

const ProjectNewAddCard = ({ projectList }) => {
  const { homeClickMore } = useProjectNewAddData();
  // const router = useRouter();
  const toList = () => {
    window.open(`/pages/project-new-add`);
  };
  const list = projectList.slice(0, 4)
  return <div className='project-new-add'>
    {/* <h2 className="title">
      <span>新开项目</span>
      <span className="pointer" onClick={() => homeClickMore(toList)}>
        更多
        <i className={cls('iconfont', 'icon-slider-right')} />
      </span>
    </h2> */}
    <div className='main-container'>
    <HomeTitle title={'新开项目'} />
    <div className="list">
      {
        list.map(project => <div className='item'>
          <Link href={`/pages/project-new-add/${project.id}`}>
            <div>
              <div className='head'>
                <Image src={Icon} width={60} height={60} />
                <div className='right'>
                  <div className='project-name ellipsis' title={project.projectName}>{project.projectName}</div>
                  <div className='org-list'>
                    {project.twoOrgName && <div className='org-name' title={project.twoOrgName}>{project.twoOrgName}</div>}
                    {project.threeOrgName && <div className='org-name' title={project.threeOrgName}>{project.threeOrgName}</div>}
                  </div>
                </div>
              </div>
              <div className='footer'>
                <div>
                  <span>{!!(project.province || project.city) && '项目地址：'}{project.province}{project.city}</span>
                  <span>开工时间：{dateFormat(project.actualBeginDate, 'YYYY-MM-DD')}</span>
                </div>
                <span className="pointer">
                  详情
                  <i className={cls('iconfont', 'icon-slider-right')} />
                </span>
              </div>
            </div>
          </Link>
        </div>)
      }
    </div>
    <div className='btn' onClick={() => homeClickMore(toList)}>查看更多</div>
    </div>
    <style jsx>{`
      .project-new-add {
        padding: 36px 0 68px;
        background-image: url(${ProjectNewAddBg});
        background-size: cover;
      }
      .main-container {
        width: 1200px;
        height: auto;
        margin: 0 auto;
      }
      .title {
        height: 32px;
        line-height: 32px;
        margin-bottom: 0px;
        font-size: 24px;
        font-weight: 400;
        position: relative;
        color: #333;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 30px;
        margin-bottom: 20px;
      }
      .list {
        display: flex;
        flex-wrap: wrap;
      }
      .item {
        width: 594px;
        margin-right: 12px;
        margin-bottom: 12px;
        padding: 24px 20px;
        background: #fff;
        border: 1px solid #E9EFF4;
        cursor: pointer;
      }
      .item:nth-child(2n) {
        margin-right: 0;
      }
      .pointer {
        cursor: pointer;
        font-size: 14px;
      }
      .iconfont {
        font-size: 14px;
        color: #737687;
      }
      .head {
        height: 60px;
        display: flex;
        margin-bottom: 20px;     
      }
      .right {
        margin-left: 20px;
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: calc(100% - 80px);
      }
      .project-name {
        font-size: 18px;
        line-height: 24px;
        font-weight: 600;
      }
      .project-name:hover {
        color: #018DD7;
      }
      .org-list {
        display: flex;
      }
      .org-name {
        border-radius: 6px;
        background: #EAF1FB;
        // display: flex;
        padding: 6px 15px;
        // justify-content: center;
        // align-items: center;
        font-size: 12px;
        line-height: 16px;
        color: #737687;
        margin-right: 8px;
        max-width: 232px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .footer {
        color: #737687;
        display: flex;
        justify-content: space-between;
      }
      .ellipsis {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .btn {
        display: flex;
        width: 136px;
        height: 36px;
        justify-content: center;
        align-items: center;
        border-radius: 18px;
        background: #FFF;
        box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.10);
        font-size: 14px;
        color: #666666;
        margin: 20px auto 0;
        cursor: pointer;
      }
    `}</style>
  </div>
}
export default ProjectNewAddCard;